import { useState, useEffect, memo } from "react";

import { useFlairStore } from "stores/FlairStore";

import { TheAudio } from "./lib/audio";

// -----------------------------------------------------------------------------

const TheCode = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "KeyB",
  "KeyA",
].join();

// -----------------------------------------------------------------------------

export const SpecialThing = memo(function SpecialThing() {
  const [playSpecialThing, setPlaySpecialThing] = useState(false);

  const [, flairActions] = useFlairStore();

  //
  useEffect(() => {
    if (playSpecialThing) {
      return;
    }

    //
    const input: string[] = [];
    const onKeyUp = (e: KeyboardEvent) => {
      input.push(e.code);

      if (input.length > 10) {
        input.shift();
      }

      if (input.join() === TheCode) {
        input.length = 0;
        setPlaySpecialThing(true);
        flairActions.startCelebration();
      }
    };

    //
    window.document.addEventListener("keyup", onKeyUp);

    //
    return () => window.document.removeEventListener("keyup", onKeyUp);
  }, [playSpecialThing, flairActions]);

  //
  return playSpecialThing ? (
    <audio
      controls={false}
      autoPlay={true}
      onEnded={() => setPlaySpecialThing(false)}
    >
      <source src={TheAudio} />
    </audio>
  ) : null;
});
